import PropTypes from 'prop-types';

import { fonts, oldFontSizes, pageWidth } from '../../style/theme';
import { scale } from '../../util/scale';
import { serifParagraph } from '../../style/article';

import ContentfulProjectPage from './ContentfulProjectPage';

export const textBlock = scale({
  textAlign: 'left',
  margin: '26px auto',
  maxWidth: pageWidth,
});

export const tableStyle = scale({
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    border: '1px solid #eee',
    lineHeight: 1.4,
    th: {
      border: '1px solid rgb(68,157,124)',
      backgroundColor: 'rgb(68,157,124)',
      color: 'white',
      padding: '16px',
      textAlign: 'left',
      fontWeight: 600,
      a: {
        color: 'white',
      },
    },
    td: {
      border: 'none', // Remove vertical border between cells in body rows
      borderBottom: '1px solid #eee', // Add horizontal border under body rows
      padding: '16px',
    },
    'tr:nth-of-type(odd) td': {
      // Add this line
      backgroundColor: '#f4f4f4',
    },
    'tr:nth-of-type(even) td': {
      // Add this line
      backgroundColor: 'white',
    },
  },
});

export const projectSubHeader = scale({
  fontFamily: fonts.Sans,
  fontWeight: 700,
  fontSize: '32px',
  lineHeight: '40px',
  marginLeft: 0,
  marginTop: 62,
});

export const projectH3 = scale({ fontSize: 24, lineHeight: '48px' });

export const projectText = serifParagraph;

export const simpleListStyle = scale({
  marginBottom: '32px',
  li: serifParagraph,
  a: {
    color: 'var(--text-primary)',
    textDecoration: 'underline',
    ':hover': {
      color: 'black',
    },
  },
});

export const imageStyle = scale({
  width: '100%',
  margin: 'auto',
  marginTop: '40px',
  marginBottom: '40px',
  maxWidth: '800px',
  p: {
    margin: 'auto',
    fontSize: oldFontSizes.button,
    marginTop: '15px',
  },
});

export const blockQuote = scale({
  fontSize: [24, 24, 24, 26],
  fontStyle: 'italic',
  fontFamily: fonts.Serif,
  borderLeft: '4px solid var(--gray-8)',
  fontWeight: 600,
  borderRadius: 4,
  padding: '6px 0px 6px 24px',
  margin: '36px 0px 36px 0px',
});

const ProjectRenderer = ({ link }: { link: string; costPerTon: number }) => {
  return <ContentfulProjectPage slug={link} />;
};

ProjectRenderer.propTypes = {
  link: PropTypes.string.isRequired,
};

export default ProjectRenderer;
